module.exports = __webpack_public_path__ + "static/assets/169f7755a820bb597640f838ccc34af6.png";